import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './assets/styles/theme';

// Context Providers
import { AuthProvider } from './contexts/AuthContext';
import { SocketProvider } from './contexts/SocketContext';

//Pages (to be implemented)
import Welcome from './pages/Welcome';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import DrawingUpload from './pages/DrawingUpload';
import DrawingView from './pages/DrawingView';
import NotFound from './pages/NotFound';
import VerifyEmail from './pages/VerifyEmail';
import Profile from './pages/Profile';

// New pages for improved onboarding flow
// import Demo from './pages/Demo';
import LearnMore from './pages/LearnMore';
import Checkout from './pages/Checkout';
import OnboardingTour from './pages/OnboardingTour';
import PricingPlans from './pages/PricingPlans';
import PaymentSuccess from './pages/PaymentSuccess';

// Password recovery pages
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

// Route components
import PrivateRoute from './components/routes/PrivateRoute';
import SubscriptionRequiredRoute from './components/routes/SubscriptionRequiredRoute';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
      <SocketProvider>
      <CssBaseline />
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Welcome />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          {/* <Route path="/demo" element={<Demo />} /> */}
          <Route path="/learn-more" element={<LearnMore />} />
          <Route path="/pricing" element={<PricingPlans />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          
          {/* Protected checkout flow requiring authentication */}
          <Route path="/checkout" element={
            <PrivateRoute>
              <Checkout />
            </PrivateRoute>
          } />
          
          {/* Authentication required routes */}
          <Route path="/onboarding" element={
            <PrivateRoute>
              <OnboardingTour />
            </PrivateRoute>
          } />
          
          <Route path="/profile" element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          } />
          
          {/* Subscription required routes */}
          <Route path="/dashboard" element={
            <SubscriptionRequiredRoute>
              <Dashboard />
            </SubscriptionRequiredRoute>
          } />
          <Route path="/upload" element={
            <SubscriptionRequiredRoute>
              <DrawingUpload />
            </SubscriptionRequiredRoute>
          } />
          {/* /drawing/:id/element/:elementId and /connection/:connectionId link to one
              item (utils/itemLinks.js) — one route, so moving between items never
              remounts the drawing. */}
          <Route path="/drawing/:id/*" element={
            <SubscriptionRequiredRoute>
              <DrawingView />
            </SubscriptionRequiredRoute>
          } />
          
          {/* Payment success route */}
          <Route path="/payment-success" element={<PaymentSuccess />} />
          
          {/* Not found route */}
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </Router>
      </SocketProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
